/**
 * @generated SignedSource<<cca4819375422002e9ce00384783d7bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type inputSuggestionUserItemTemplate_UserFragment$data = {
  readonly extension: {
    readonly avatar?: {
      readonly thumbnail: string | null;
    } | null;
  } | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "inputSuggestionUserItemTemplate_UserFragment";
};
export type inputSuggestionUserItemTemplate_UserFragment$key = {
  readonly " $data"?: inputSuggestionUserItemTemplate_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"inputSuggestionUserItemTemplate_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "inputSuggestionUserItemTemplate_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "userExtensionKind",
          "value": "Academies"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumbnail",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "AcademiesUserExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(userExtensionKind:\"Academies\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d021cd9f7ea1aa841daf02543cc59c30";

export default node;
